import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { snakeCase } from 'lodash';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import displayName from 'component-lib/displayName';
import withMessages from 'component-utilities/intl';

import styles from '../ActionButtons.scss';
import actionStatuses from './actionStatuses.json';

const BASE_KEY = 'components.buttons.action_buttons';

@withMessages
export default class ActionGenerator extends Component {
    static displayName = displayName('Buttons/ActionButtons/ActionGenerator');

    static propTypes = {
        getMessage: PropTypes.func.isRequired,
        status: PropTypes.oneOf(Object.keys(actionStatuses).map(type => actionStatuses[type])),
        isTipEnabled: PropTypes.bool,
        icon: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        children: PropTypes.any,
    };

    static defaultProps = {
        status: actionStatuses.NORMAL,
        children: null,
        isTipEnabled: false,
    };

    onButtonClick = () => {
        if (!this.isActionInactive) {
            this.props.onClick();
        }
    };

    onHover = (isMouseEntering) => {
        let tooltipControl = ReactTooltip.hide;

        if (isMouseEntering) {
            tooltipControl = ReactTooltip.show;
        }

        return () => {
            if (this.isActionInactive) {
                tooltipControl(this.button);
            }
        };
    };

    get isActionInactive() {
        return this.props.status === actionStatuses.INACTIVE;
    }

    render() {
        const { getMessage, status, icon, type, children, isTipEnabled } = this.props;

        return (
            <span
                className={`${styles[`action-${icon}${status}`]} action-generator`}
                ref={(button) => {
                    this.button = button;
                }}
                data-tip={isTipEnabled ? true : undefined}
                data-for={type}
                data-action={type}
                role="button"
                tabIndex="-1"
                onClick={this.onButtonClick}
                onMouseEnter={this.onHover(true)}
                onMouseLeave={this.onHover(false)}
            >
                {getMessage(`${BASE_KEY}.${snakeCase(type)}.text`)}
                <ReactTooltip id={type} effect="solid" offset={{ top: -10 }}>
                    {isTipEnabled && this.props.getMessage(`${BASE_KEY}.${snakeCase(type)}.hover`)}
                </ReactTooltip>
                {children}
            </span>
        );
    }
}
